import { Routes } from './routes';

export const buildRoute = (route: Routes, params: Record<string, string> = {}) => {
  return `/${route
    .split('/')
    .map((part) => {
      if (!part.startsWith(':')) {
        return part;
      }

      let sanitizedParamName = part.substring(1); // remove colon from path param name

      const isOptionalPathParam = part.endsWith('?');

      if (isOptionalPathParam) {
        sanitizedParamName = sanitizedParamName.replace(/.$/, ''); // remove last character (question mark)
      }

      const includesRegexpEnum = part.includes('(');

      if (includesRegexpEnum) {
        sanitizedParamName = sanitizedParamName.substring(0, part.indexOf('(') - 1); // remove regexp from path param name
      }

      if (isOptionalPathParam) {
        return params[sanitizedParamName] ?? null; // return param value or remove optional path param name from URL if value not passed
      }

      return params[sanitizedParamName] ?? part;
    })
    .filter((param) => !!param) // filter empty path parts
    .join('/')}`;
};
